// extracted by mini-css-extract-plugin
export default {"Button":"iconButton_Button__YyAXS","NoShadow":"iconButton_NoShadow__yetD6"};